import { UserOnboardingStep } from '@core/models/identity.interface';

/**
 * Действия, которые отмечаются после нажатия на кнопку историй
 */
export const actionsToPassAfterStoriesOpening: UserOnboardingStep[] = [
  'show-stories-tooltip:daily-content',
  'show-stories-tooltip:next-step',
];
